import axios from 'axios';

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const API = (token) =>
  axios.create({
    baseURL: BASE_URL,
    headers: { Authorization: token },
  });

const getToken = () => localStorage.getItem('userToken');

// ─── LOGIN ────────────────────────────────────────────────────────────────────
// Accepts either email or username as identifier
export const loginUser = async (body) => {
  try {
    return await axios.post(`${BASE_URL}/auth/login`, body);
  } catch (error) {
    console.error('loginUser error:', error);
    throw error;
  }
};

// ─── REGISTER ─────────────────────────────────────────────────────────────────
export const registerUser = async (body) => {
  try {
    return await axios.post(`${BASE_URL}/auth/register`, body);
  } catch (error) {
    console.error('registerUser error:', error);
    throw error;
  }
};

// ─── VALIDATE TOKEN ───────────────────────────────────────────────────────────
export const validUser = async () => {
  try {
    const token = getToken();
    if (!token) return null;
    const { data } = await API(token).get('/auth/valid');
    return data;
  } catch (error) {
    console.error('validUser error:', error);
    return null;
  }
};

// ─── LOGOUT ──────────────────────────────────────────────────────────────────
export const logoutUser = async () => {
  try {
    const token = getToken();
    if (token) await API(token).get('/auth/logout');
  } catch (_) {
    // Ignore network errors on logout
  } finally {
    localStorage.removeItem('userToken');
  }
};

// ─── SEARCH USERS ─────────────────────────────────────────────────────────────
// Result is role-filtered server-side: clients get admins only, admins get everyone
export const searchUsers = async (query) => {
  try {
    const token = getToken();
    return await API(token).get(`/api/user?search=${encodeURIComponent(query)}`);
  } catch (error) {
    console.error('searchUsers error:', error);
    return { data: [] };
  }
};

// ─── GET USER BY ID ──────────────────────────────────────────────────────────
export const getUserById = async (id) => {
  try {
    const token = getToken();
    const { data } = await API(token).get(`/api/users/${id}`);
    return data;
  } catch (error) {
    console.error('getUserById error:', error);
  }
};

// ─── UPDATE PROFILE ──────────────────────────────────────────────────────────
export const updateUser = async (id, body) => {
  try {
    const token = getToken();
    const { data } = await API(token).patch(`/api/users/update/${id}`, body);
    return data;
  } catch (error) {
    console.error('updateUser error:', error);
    throw error;
  }
};

// ─── GET ALL ADMINS ──────────────────────────────────────────────────────────
export const getAdmins = async () => {
  try {
    const token = getToken();
    const { data } = await API(token).get('/api/admins');
    return data;
  } catch (error) {
    console.error('getAdmins error:', error);
    return [];
  }
};

// ─── CHECK VALID & REDIRECT ──────────────────────────────────────────────────
export const checkValid = async () => {
  const data = await validUser();
  if (!data?.user) {
    window.location.href = '/login';
  } else {
    window.location.href = '/chats';
  }
};
